export default "__VITE_ASSET__71079997__"